export default __webpack_public_path__ + "static/media/Snd_CA.7cc41631.mp3";